import { __assign, __rest } from "tslib";
import React from 'react';
import { List, ListItem, Button, } from '@chakra-ui/react';
export function ButtonList(props) {
    var items = props.items, rest = __rest(props, ["items"]);
    return (React.createElement(List, __assign({ spacing: 2 }, rest), items.map(function (item, index) { return (React.createElement(ListItem, { key: index },
        React.createElement(Button, __assign({ justifyContent: "start", isFullWidth: true, variant: "outline", borderColor: "black", borderWidth: 2 }, item)))); })));
}
